<template>
  <v-overlay :value="showOverlay">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
</template>
<script>
const TIMEOUT = 20000; // 20 Second timeout
export default {
  name: 'app-overlay',
  data() {
    return {
      timeout: null,
    }
  },
  computed: {
    showOverlay() {
      return this.$store.state.showOverlay;
    },
  },
  mounted() {
    this.timeout = setTimeout(this.hideOverlay, TIMEOUT)
  },
  destroyed() {
    this.timeout = null;
    this.$store.commit('hideOverlay');
  },
  methods: {
    hideOverlay() {
      this.$store.commit('hideOverlay');
    }
  }
};
</script>
